import React from "react";
import "./UserListItem.scss";
import Paragraph from "./Paragraph";
import Flex from "./Flex";
import BadgeLevel from "./BadgeLevel";
import Avatar from "./Avatar";

const UserListItem = ({ name, badge, avatar, role, children }) => {
  return (
    <Flex
      direction={"row"}
      className={"UserListItem"}
      justify={"between"}
      align={"center"}
      gap={300}
    >
      <Flex style={{ gap: "var(--size-150)" }} align={"center"}>
        <Avatar size="medium" avatar={avatar} altText={name} role={role} />
        <Paragraph size="medium">{name}</Paragraph>
      </Flex>
      <Flex gap={100} align={"center"}>
        {children}
        <Flex className={"BadgeLevelContainer"}>
          <BadgeLevel badge={badge} />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default UserListItem;
